import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import {
  HoInvitedReadyToStart,
  Layout,
  NewsLetterBar,
  SharedHero,
} from '../../v2/components/common';
import {
  BetterWayToBuild,
  TrustedByContractorsLogo,
} from '../../v2/components/invited-by-insurance';

const InvitedByInsurance: React.FC = () => (
  <Layout title="Invited by insurance">
    <SharedHero
      bg="green.500"
      haveBackground
      haveContentChildren={false}
      heading="Why did my insurer invite me to use HOVER?"
      body="Dealing with property damage is stressful enough—filing a claim should be the easiest part."
      desktopImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          objectFit="contain"
          alt="invited by insurance hero"
          src="../../v2/assets/images/invited_by_insurance_hero_desktop.png"
        />
      }
      mobileAndTabletImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          alt="invited by insurance hero"
          src="../../v2/assets/images/invited_by_insurance_hero_tablet.png"
        />
      }
    />
    <BetterWayToBuild />
    <TrustedByContractorsLogo />
    <HoInvitedReadyToStart backgroundColor="green.500" />
    <NewsLetterBar />
  </Layout>
);

export default InvitedByInsurance;
